import { render, staticRenderFns } from "./orderFreeDialog.vue?vue&type=template&id=b80728ce&scoped=true"
import script from "./orderFreeDialog.vue?vue&type=script&lang=js"
export * from "./orderFreeDialog.vue?vue&type=script&lang=js"
import style0 from "./orderFreeDialog.vue?vue&type=style&index=0&id=b80728ce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80728ce",
  null
  
)

export default component.exports